import axios, {AxiosResponse} from 'axios'
import {getCookie} from '../../../../../utils/cookie'

const API_URL = process.env.REACT_APP_API_BASE_URL
const API_KEY: any = process.env.REACT_APP_API_KEY
export const REGISTER_URL = `${API_URL}/v1/ekyc/account/update`
export const GETACCOUNTINFO_URL = `${API_URL}/v1/ekyc/account/info`
export const ECONTRACTSIGNLINK = `${API_URL}/v1/ekyc/econtract/sign-links/require`
export const ECONTRACTLIST = `${API_URL}/v1/ekyc/econtract/sign-links/list`
export const LOGIN = `${API_URL}/v1/auth/qr-login`
export const GETTOKEN = `${API_URL}/v1/ekyc/vnpt-auth`

export const updateAccount = async (data: any) => {
  const response = await axios.post(REGISTER_URL, data, {
    headers: {
      'x-api-key': API_KEY,
      'Access-Control-Allow-Origin': '*',
      'session-id': getCookie('SESSION_ID'),
    },
  })
  return response.data
}

export const getAcconutInfo = async (data: any) => {
  const response = await axios.post(GETACCOUNTINFO_URL, data, {
    headers: {
      'x-api-key': API_KEY,
      'Access-Control-Allow-Origin': '*',
      'session-id': getCookie('SESSION_ID'),
    },
  })
  return response.data
}

export const getEcontractSignLinks = async (data: any) => {
  const response = await axios.post(ECONTRACTSIGNLINK, data, {
    headers: {
      'x-api-key': API_KEY,
      'Access-Control-Allow-Origin': '*',
    },
  })
  return response.data
}

export const getContractList = async (data: any) => {
  const response = await axios.post(ECONTRACTLIST, data, {
    headers: {
      'x-api-key': API_KEY,
      'Access-Control-Allow-Origin': '*',
    },
  })
  return response.data
}

export const login = async (data: any) => {
  const response = await axios.post(LOGIN, data, {
    headers: {
      'x-api-key': API_KEY,
      'Access-Control-Allow-Origin': '*',
    },
  })
  return response.data
}

export const getToken = async (data?: any) => {
  const response = await axios.post(GETTOKEN, data, {
    headers: {
      'x-api-key': API_KEY,
      'Access-Control-Allow-Origin': '*',
    },
  })
  return response.data
}
